import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const DEFAULT = {
  name: "جسر",
  tagline: "جسر ذكي بين أنظمتك",
  logo_base64: null,
  primary_color: "#004EEB",
};

const PlatformContext = createContext(DEFAULT);

export function PlatformProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/platform/settings");
      setSettings({ ...DEFAULT, ...data });
    } catch {
      // silently use defaults
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  // Update <title> whenever name changes
  useEffect(() => {
    document.title = settings.name;
  }, [settings.name]);

  // Update favicon whenever logo_base64 changes
  useEffect(() => {
    if (!settings.logo_base64) return;
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.type = settings.logo_base64.startsWith("data:image/svg") ? "image/svg+xml" : "image/png";
    link.href = settings.logo_base64;
  }, [settings.logo_base64]);

  return (
    <PlatformContext.Provider value={{ ...settings, reload: load, updateSettings: setSettings }}>
      {children}
    </PlatformContext.Provider>
  );
}

export function usePlatform() {
  return useContext(PlatformContext);
}
